import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// Protected layout
const ProtectedLayout = ({ children }) => {
    const auth = useSelector(state => state?.productData?.users);
    if (!auth?.user?.email) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default ProtectedLayout;
